import React, { useContext, useState } from "react";
import { useTts } from "tts-react";

import { Button, RichContentDisplay } from "@examspark/common-ui";
import {
  IconPauseLine,
  IconPlayLine,
} from "@examspark/common-ui/dist/components/icons";
import {
  ExamConfigContext,
  ExamFlagsContext,
} from "@examspark/exam-ui-context";

interface Props {
  content: string;
}

const RichContentTtsDisplay = (props: Props) => {
  const examConfig = useContext(ExamConfigContext);
  const examFlags = useContext(ExamFlagsContext);
  const [html, setHtml] = useState<JSX.Element>();
  const { ttsChildren, state, play, pause } = useTts({
    children: html,
    markTextAsSpoken: true,
  });

  const showReadAloud = examConfig?.enableReadAloud && examFlags?.textToSpeech;

  return (
    <>
      {showReadAloud && (
        <Button
          title="Click to Speak"
          onClick={() => (state.isPlaying ? pause() : play())}
          variant="outlined"
          icon={state.isPlaying ? <IconPauseLine /> : <IconPlayLine />}
        >
          Read Aloud
        </Button>
      )}
      <RichContentDisplay
        content={props.content}
        wrapper={(html: JSX.Element) => {
          setHtml(html);

          // swap to ttsChildren only if the TTS is playing.
          // This forces the DOM to update and ensures the MarkTextAsSpoken
          // stuff they are doing doesn not break our Highlighter.
          if (state.isPlaying) {
            return <>{ttsChildren}</>;
          }
          return html;
        }}
      />
    </>
  );
};

export default RichContentTtsDisplay;
